import type { CompanyStatus, SubmissionStatus } from '../lib/types.ts';
import { companyStatusLabel, type StatusAudience } from '../lib/companyStatus.ts';

const COMPANY_CLS: Record<CompanyStatus, string> = {
  invited: 'bg-slate-100 text-slate-700',
  in_progress: 'bg-blue-50 text-blue-700',
  review: 'bg-amber-50 text-amber-700',
  changes: 'bg-orange-50 text-orange-700',
  compliant: 'bg-emerald-50 text-emerald-700',
  expired: 'bg-red-50 text-red-700',
  deactivated: 'bg-slate-200 text-slate-600',
};

const SUBMISSION_LABELS: Record<SubmissionStatus, { label: string; cls: string }> = {
  pending: { label: 'Pending', cls: 'bg-slate-100 text-slate-700' },
  approved: { label: 'Compliant', cls: 'bg-emerald-50 text-emerald-700' },
  rejected: { label: 'Not Compliant', cls: 'bg-orange-50 text-orange-700' },
  not_applicable: { label: 'N/A', cls: 'bg-slate-100 text-slate-600' },
};

/**
 * `audience` defaults to 'admin' because the admin app has far more call sites
 * and all of them predate the split. The portal passes 'vendor' explicitly.
 */
export function CompanyStatusBadge({
  status,
  audience = 'admin',
}: {
  status: CompanyStatus;
  audience?: StatusAudience;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${COMPANY_CLS[status]}`}
    >
      {companyStatusLabel(status, audience)}
    </span>
  );
}

export function SubmissionStatusBadge({ status }: { status: SubmissionStatus }) {
  const cfg = SUBMISSION_LABELS[status];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${cfg.cls}`}
    >
      {cfg.label}
    </span>
  );
}
